<template>
    <div class="d-flex">
        <div>
            <div class="group relative inline-block mr-3">
                <button
                    v-if="isPrevEnabled"
                    type="button"
                    class="btn btn-secondary"
                    :class="{'disabled' : !isPrevEnabled}"
                    @click="showPrev">
                    <icon name="arrow-left" class="w-5 h-5 cursor-pointer"/>
                </button>
                <div class="tooltip-tl">
                    <span class="tooltip-tl-text"></span>
                    {{ prevAuctionToolTip | formatDay }}
                 </div>
            </div>
        </div>
        <div>
            <div class="group relative inline-block">
                <button
                    v-if="isNextEnabled"
                    type="button"
                    class="btn btn-secondary"
                    :class="{'disabled' : !isNextEnabled}"
                    @click="showNext">
                    <icon name="arrow-right" class="w-5 h-5 cursor-pointer"/>
                </button>
                <div class="tooltip-tl">
                    <span class="tooltip-tl-text"></span>
                    {{ nextAuctionToolTip | formatDay }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon';
import { Link } from '@inertiajs/vue2';

export default {
    components: {
        Icon,
        Link
    },
    props: {
        auctions: Array,
        current: Object,
    },
    methods: {
        showPrev() {
            let index = this.indexOf(this.current);
            if(index < 1) {
                return;
            }
            this.$emit('update', this.auctions[index - 1]);
        },
        showNext() {
            let index = this.indexOf(this.current);
            if(index >= this.auctions?.length - 1) {
                return;
            }
            this.$emit('update', this.auctions[index + 1]);
        },
        indexOf(auction) {
            return (this.auctions && auction) ? this.auctions.findIndex( a => a.id === auction.id ) : -1;
        }
    },
    computed: {
        isNextEnabled() {
            return this.indexOf(this.current) < this.auctions?.length - 1;
        },
        isPrevEnabled() {
            return this.indexOf(this.current) > 0;
        },
        prevAuctionToolTip() {
            let currentIndex = this.indexOf(this.current) || -1;
            return (currentIndex > 0) ? this.auctions[currentIndex - 1]?.date_start : '';
        },
        nextAuctionToolTip() {
            let currentIndex = this.indexOf(this.current) || -1;
            return (currentIndex + 1 <= this.auctions?.length) ? this.auctions[currentIndex + 1]?.date_start : '';
        }
    }
}
</script>
